export default "/_nuxt/ca3d55f016e3fad5a6eba20a39b40f68.svg";